'use strict';

const $body = $('body');
const { queryFirst, hasClass, removeClass, addClass, matchesBreakpoint, queryAll } = require('../domUtil');
const { trackWishlist } = require('../components/etmc');
const { AlertDialog } = require('../components/alertDialog');
const { WISHLIST_NAME_REGEX } = require('../components/shippingPreference/constants');
const {
    HIDDEN_CLASS,
    ANIM_TIME_STANDARD_1,
    INVALID_CLASS,
    EVENT_KEY_ENTER,
    EVENT_KEY_SPACE,
    EVENT_KEY_TAB,
    KBD_CLASS
} = require('../constants');
const { SELECTOR_PRODUCT_TILE } = require('../productTiles/productTileConstants');
const { getSelectedSizeData } = require('../productTiles/utils/productTileData');
const { showStrikeHearts, hideStrikeHearts } = require('../wishlist/helper');
const { getFreshCsrfToken } = require('../utils/csrfRefresh');

const isMobile = !matchesBreakpoint('lg');
const WishlistItemsMgr = require('../wishlist/wishlistItemsMgr').default;
const configElement = queryFirst('#wishlist-settings');
const isCartPage = !!queryFirst('.cart-page');
let touchTimer;
const LONG_PRESS_THRESHOLD = 700;

/**
 * True after a keydown while #create-wishlist is open (tab/type inside the sheet).
 * interactionDetect strips m-kbdactive on pointer events, so closing with a click often clears the class before we restore.
 */
let createWishlistModalUsedKeyboardWhileOpen = false;
/** Set in hide.bs.modal: restore keyboard modality after this close (see applyStoredCreateWishlistKeyboardModality). */
let createWishlistModalRestoreKeyboardAfterClose = false;
let createWishlistModalKeydownCaptureBound = false;

function applyStoredCreateWishlistKeyboardModality() {
    if (!createWishlistModalRestoreKeyboardAfterClose) {
        return;
    }
    createWishlistModalRestoreKeyboardAfterClose = false;
    addClass(document.body, KBD_CLASS);
    if (typeof window !== 'undefined') {
        window.__lastWasKeyboard = false;
    }
}


/**
 * Callback for change button on mobile devices
 * @param {Array} lists lists to show
 */
function mobileChangeButtonCallback(lists) {
    const wishlistsContainer = queryFirst('.js-wishlist-items-container');
    while (wishlistsContainer.firstChild) {
        wishlistsContainer.removeChild(wishlistsContainer.firstChild);
    }
    lists.forEach(item => {
        const alertInner = document.createElement('div');
        alertInner.textContent = item.text;
        alertInner.classList.add('wishlist-sheet-item');
        if (item.customCSSClass?.length) {
            item.customCSSClass.forEach(cssClass => alertInner.classList.add(cssClass));
        }
        wishlistsContainer.appendChild(alertInner);
        alertInner.addEventListener('click', () => {
            if (typeof item.callback === 'function') {
                item.callback();
            }
        });
    });
    $('#wishlists').modal('show');
}

/**
 * Return information about product
 * @param {HTMLElement} icon clicked WL icon
 * @returns {Object} product info
 */
function getClickedProductInfo(icon) {
    const { productId: pid, uuid } = icon.dataset;
    let giftCardAmount = 0;
    let isGiftCard = false;

    isGiftCard = hasClass(icon.closest('.js-product-tile'), 'js-gift-card-tile') || hasClass(icon.closest('.product-detail'), 'gift-card-main');

    if (isGiftCard) {
        giftCardAmount = queryFirst('#gift_card_amount').value || 0;
    }

    let optionId = queryFirst('.js-color-attribute .swatch-circle.selected', icon.closest('.product-detail'))?.dataset?.attrValue || queryFirst('.js-tile-swatch.selected', icon.closest('.js-product-tile'))?.dataset?.attrValue || null;
    let optionVal = queryFirst('.size-btn.selected', icon.closest('.product-detail'))?.dataset?.valueId || queryFirst('.size-btn.selected', icon.closest('.js-product-tile'))?.dataset?.valueId || null;

    return { pid, isGiftCard, giftCardAmount, optionId, optionVal, uuid };
}

/**
 * Callback for WL heart
 * @param {HTMLElement} icon WL icon
 * @param {string} listId Wishlist ID
 * @returns {boolean} - succesfull or failure result
 */
function wishlistIconCallback(icon, listId = false) {
    const href = configElement?.dataset?.wishlistAdditemLink || '';

    const addWishlistButtonData = getClickedProductInfo(icon);

    if (!href || !addWishlistButtonData.pid) {
        return false;
    }
    addProductToWishlist(href, addWishlistButtonData, listId, icon);

    return true;
}

/**
 * Mark item as added to Wishlist
 * @param {HTMLElement} icon wishlist icon
 */
function fillWishlistIcon(icon) {
    addClass(icon, 'added-to-wish-list');
}
/**
 * Mark item as added to Wishlist
 * @param {HTMLElement} icon wishlist icon
 */
function unfillWishlistIcon(icon) {
    removeClass(icon, 'added-to-wish-list');
}

/**
 * Returns configuration on lists
 * @param {HTMLElemet} button clicked WL icon
 * @returns {Promise} Promise with items
 */
function getWishlistItemsWithConfig(button) {
    const wishlistMgr = WishlistItemsMgr.getInstance();
    const { productId: pid } = button.dataset;
    return wishlistMgr
        .getWishlistItems()
        .then(response => {
            const { wishlistItems: items } = response;

            return Promise.all(
                items.map(item => {
                    const cta = [];
                    const customCSSClass = [];
                    let attributes = [];
                    let callback = null;

                    return wishlistMgr.isItemInWishlist(pid, item.UUID).then(state => {
                        if (state) {
                            customCSSClass.push('m-selected');
                            attributes = {
                                'role': 'option',
                                'aria-disabled': 'true'
                            }
                        } else {
                            callback = () => wishlistIconCallback(button, item.UUID);
                            attributes = {
                                'role': 'option'
                            }
                        }
                        customCSSClass.push(`listid-${item.UUID}`);
                        return {
                            text: item.listName,
                            attributes: attributes,
                            callback: callback,
                            cta,
                            customCSSClass
                        };
                    });
                })
            );
        })
        .then(resolvedTexts => {
            if (!resolvedTexts.length) {
                // added for perfomance purpose to avoid creating lists on hovering and first load
                // first WL will be create on adding first item to WL or oppening WL page directrly
                resolvedTexts.push({
                    text: configElement?.dataset.defaultName,
                    attributes: {
                        'role': 'option'
                    },
                    callback: () => wishlistIconCallback(button)
                });
            }
            const createNewListBtn = {
                text: 'Create a new list',
                attributes: {
                    'role': 'option'
                },
                customCSSClass: ['m-new'],
                callback: () => {
                    let productMovedToWishlist = getClickedProductInfo(button);
                    $('#create-wishlist').modal('show');
                    $('#wishlists').modal('hide');
                    handleAddToWishlistActions(productMovedToWishlist, button);
                }
            };
            resolvedTexts.push(createNewListBtn);

            return resolvedTexts;
        });
}

/**
 * Show allert message
 * @param {*} button clicked WL icon
 * @param {Object} data add to WL response
 * @returns {void}
 */
function displayAlert(button, data) {
    const modal = button.closest('.modal.show');
    const host = modal || document.body;

    const isSuccessAdd =
        Array.isArray(data.containerClass) &&
        data.containerClass.indexOf('wishlist-alert-dialog-success') !== -1;

    const viewCta = {
        text: 'View',
        callback: () => {
            const redirectLink = configElement?.dataset?.wishlistShowLink || '';
            if (redirectLink && data.wishListUUID) {
                const url = new URL(redirectLink, window.location.origin);
                url.searchParams.set('id', data.wishListUUID);
                window.location.href = url.toString();
            }
        }
    };
    if (isSuccessAdd) {
        viewCta.ariaLabel = `Success. ${data.text}. View`;
    }

    const alertConfig = {
        host: host,
        type: isSuccessAdd ? 'alert' : 'dialog',
        labelText: isSuccessAdd ? '' : `Wish List message:`,
        focusAfterClose: button,
        items: [
            {
                text: data.text,
                cta: [viewCta]
            }
        ],
        customCSSClass: data.containerClass ? data.containerClass : []
    };

    if (isMobile) {
        alertConfig.items[0].cta.splice(0, 0, {
            text: '+ to another list',
            callback: () => {
                getWishlistItemsWithConfig(button).then(resolvedTexts => {
                    mobileChangeButtonCallback(resolvedTexts, button);
                });
            }
        });
    } else {
        // not mobile
        const position = button.getBoundingClientRect();
        const isRightPos = window.innerWidth - position.right < 160;

        alertConfig.style = 'top:' + position.top + 'px;left:' + position.left + 'px;';

        if (isRightPos) {
            alertConfig.customCSSClass.push('m-right');
        }
    }

    return new AlertDialog(alertConfig);
}

/**
 * Input validation
 * @param {HTMLInputElement} input input
 * @param {HTMLElement} invalidFeedback validation message
 */
function validateInputCallback(input, invalidFeedback) {
    const listNameTrimText = input && input.value && input.value.trim();
    const { missingError, patternMismatch } = input.dataset;
    if (!listNameTrimText) {
        addClass(input, INVALID_CLASS);
        invalidFeedback.textContent = missingError;
    } else if (!WISHLIST_NAME_REGEX.test(listNameTrimText)) {
        addClass(input, INVALID_CLASS);
        invalidFeedback.textContent = patternMismatch;
    } else {
        removeClass(input, INVALID_CLASS);
    }
}

/**
 * handles all the actions to add the product to wishlist.
 * @param {Object} wishlistedProductData - Object with product id, option id, option value, isGiftCard and giftCardAmount details
 * @param {jQuery.event} event - Event object which trigger the action
 */
function handleAddToWishlistActions(wishlistedProductData, event) {
    const existingListCollectionContent = queryFirst('.existing-list-collections');
    const createNewCollection = queryFirst('.create-list-collection');
    const listNameInput = queryFirst('#list-name');
    const sheetContainer = queryFirst('.wishlist-sheet');
    const invalidFeedback = queryFirst('.invalid-feedback', createNewCollection);
    listNameInput.value = '';
    removeClass(sheetContainer, INVALID_CLASS);
    removeClass(listNameInput, INVALID_CLASS);
    invalidFeedback.textContent = '';
    listNameInput.addEventListener('blur', function (e) {
        validateInputCallback(listNameInput, invalidFeedback);
    });

    async function createNewList(e) {
        e.preventDefault();
        const createCollectionLink = configElement?.dataset?.createCollectionLink || '';
        if (!createCollectionLink) {
            return;
        }
        let listName = listNameInput.value && listNameInput.value.trim();

        if (!listName || !WISHLIST_NAME_REGEX.test(listName)) {
            addClass(sheetContainer, INVALID_CLASS);
            return;
        }
        invalidFeedback.textContent = '';

        removeClass(sheetContainer, INVALID_CLASS);
        removeClass(listNameInput, INVALID_CLASS);
        listName = listName.replace(/\s\s+/g, ' ');
        const $createListSheetBody = $('#create-wishlist .sheet-body').first();
        $createListSheetBody.spinner().start();
        const csrfToken = await getFreshCsrfToken();
        $.ajax({
            url: createCollectionLink,
            type: 'post',
            dataType: 'json',
            data: {
                wishlistName: listName,
                csrf_token: csrfToken
            },
            success: function (data) {
                $createListSheetBody.spinner().stop();
                if (data.csrfError) {
                    document.body.dispatchEvent(new CustomEvent('csrf:error'));
                    return;
                }
                if (data.success) {
                    const wishlistAdditemLink = configElement?.dataset?.wishlistAdditemLink || '';
                    const listUUID = data.wishListUUID;
                    addClass(existingListCollectionContent, HIDDEN_CLASS);
                    const wishlistMgr = WishlistItemsMgr.getInstance();
                    wishlistMgr.updateWishlistItems(data.wishlistItems);
                    $('#create-wishlist').modal('hide');
                    applyStoredCreateWishlistKeyboardModality();
                    addProductToWishlist(wishlistAdditemLink, wishlistedProductData, listUUID, event);
                } else {
                    invalidFeedback.textContent = data.msg;
                    addClass(listNameInput, INVALID_CLASS);
                }
            },
            error: function (err) {
                $createListSheetBody.spinner().stop();
                if (err?.responseJSON?.csrfError) {
                    document.body.dispatchEvent(new CustomEvent('csrf:error'));
                    return;
                }
                $('#create-wishlist').modal('hide');
            }
        });
    }

    $(queryFirst('.wishlist-sheet'))
        .off('click submit')
        .on('click', '.add-new-list', createNewList)
        .on('submit', 'form.wishlist-create-form', createNewList);
}

/**
 * Adds Product to wishlist
 * @param {string} url - service url to add product to wishlist
 * @param {Object} wishlistedProductData - Object with product id, option id, option value, isGiftCard and giftCardAmount Details
 * @param {boolean} listId - wishlist ID
 * @param {Object} buttonElement - button that was clicked to add a product to the wishlist
 */
async function addProductToWishlist(url, wishlistedProductData, listId, buttonElement) {
    const { pid, isGiftCard, giftCardAmount, optionId, optionVal, uuid } = wishlistedProductData;
    const csrfToken = await getFreshCsrfToken();
    $body.trigger('addItemToList', buttonElement.closest('.product-tile'));
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: {
            pid: pid,
            optionId: optionId,
            optionVal: optionVal,
            isGiftCard,
            id: listId,
            giftCardAmount,
            csrf_token: csrfToken
        },
        success: function (data) {
            if (data.csrfError) {
                document.body.dispatchEvent(new CustomEvent('csrf:error'));
                return;
            }
            if (data.success) {
                // update Marketing Analytics trackWishlist event
                if (data.mcAnalyticsArray) {
                    trackWishlist(data.mcAnalyticsArray);
                }
                const wishlistMgr = WishlistItemsMgr.getInstance();
                addClass(queryFirst(`.listid-${listId}`), 'm-selected');
                wishlistMgr.updateWishlistItems(data.wishlistItems);
                initWishlistIconState();
                if (isCartPage) {
                    const removeLink = queryFirst('.remove-product', buttonElement.closest(`.product-info[data-uuid="${uuid}"]`));
                    removeLink?.click();
                } else {
                    displayAlert(buttonElement, { text: data.msg, wishListUUID: data.listId, containerClass: ['wishlist-alert-dialog-success'] });
                }
            }

            if (data.error) {
                if (data.errorReason === 'Restricted') {
                    const parentContainer = buttonElement.closest('.wishlist-actions');
                    addClass(queryFirst(`.add-to-wish-list[data-product-id="${pid}"]`, parentContainer)?.parentElement, HIDDEN_CLASS);
                    const strikeHeart = queryFirst(`.strike-wish-list[data-product-id="${pid}"]`, parentContainer);
                    if (strikeHeart) {
                        removeClass(strikeHeart.parentElement, HIDDEN_CLASS);
                        strikeHeart.click();
                    }
                } else if (data.msg) {
                    displayAlert(buttonElement, { text: data.msg });
                }
            }
        },
        error: function (err) {
            if (err?.responseJSON?.csrfError) {
                document.body.dispatchEvent(new CustomEvent('csrf:error'));
                return;
            }
            displayAlert(buttonElement, err);
        }
    });
}

/**
 * Shows alert with wishlists
 * @param {Array} resolvedTexts array of wishlists
 * @param {HTMLElemet} button clicked heart
 * @returns {AlertDialog} Alert dialog
 */
function showAlertDialog(resolvedTexts, button, isKeyboardTrigger = false) {
    const modal = button.closest('.modal.show');
    const host = modal || document.body;

    const alertConfig = {
        host: host,
        labelText: 'Choose a wishlist',
        type: 'dialog',
        items: resolvedTexts,
        customCSSClass: ['wishlist-alert-dialog'],
        focusAfterClose: button,
        kbdMode: !!isKeyboardTrigger
    };

    const position = button.getBoundingClientRect();
    const isRightPos = window.innerWidth - position.right < 160;
    const maxHeight = 249;
    let style = '';

    if ( window.innerHeight < (position.bottom + maxHeight) && host === modal) {
        alertConfig.customCSSClass.push('m-bottom');
    }
    style += 'top:' + position.top + 'px;';
    style += 'left:' + position.left + 'px;';

    alertConfig.style = style;

    if (isRightPos) {
        alertConfig.customCSSClass.push('m-right');
    }

    return new AlertDialog(alertConfig);
}

/**
 * Update wishlist icon state depend on existing in WL
 * @param {HTMLElement} icon WL icon
 * @param {string} pid product ID
 */
function updateWishlistIcon(icon, pid) {
    const wishlistMgr = WishlistItemsMgr.getInstance();
    wishlistMgr.isItemInWishlist(pid).then(state => {
        if (state) {
            fillWishlistIcon(icon);
        } else {
            unfillWishlistIcon(icon);
        }
    });
}

/**
 * Initialize wishlist icons
 */
function initWishlistIconState() {
    const wishlistIcons = queryAll('.add-to-wish-list');
    wishlistIcons.forEach(icon => {
        const pid = icon.dataset?.productId;
        if (pid) {
            updateWishlistIcon(icon, pid);
        }
    });
}

module.exports = {
    addToWishlist: function () {
        let currentTriggerButton = null;
        let dialogHideTimeout = null;

        const $createWishlistModal = $('#create-wishlist');
        $createWishlistModal
            .off('show.bs.modal.lpWishlist hide.bs.modal.lpWishlist hidden.bs.modal.lpWishlist')
            .on('show.bs.modal.lpWishlist', function () {
                createWishlistModalUsedKeyboardWhileOpen = false;
                createWishlistModalRestoreKeyboardAfterClose = false;
            })
            .on('hide.bs.modal.lpWishlist', function () {
                createWishlistModalRestoreKeyboardAfterClose =
                    createWishlistModalUsedKeyboardWhileOpen ||
                    hasClass(document.body, KBD_CLASS);
            })
            .on('hidden.bs.modal.lpWishlist', function () {
                applyStoredCreateWishlistKeyboardModality();
            });

        if (!createWishlistModalKeydownCaptureBound) {
            createWishlistModalKeydownCaptureBound = true;
            document.addEventListener(
                'keydown',
                function wishlistCreateListModalKeydown(e) {
                    const modal = document.getElementById('create-wishlist');
                    if (!modal || !modal.classList.contains('show')) {
                        return;
                    }
                    if (!modal.contains(e.target)) {
                        return;
                    }
                    createWishlistModalUsedKeyboardWhileOpen = true;
                },
                true
            );
        }

        if (!isMobile) {
            $body.on('click', '.add-to-wish-list', function (e) {
                e.preventDefault();

                const button = this;
                currentTriggerButton = button;

                AlertDialog.closeAll();
                $('.popover.show').popover('hide');

                getWishlistItemsWithConfig(button).then(resolvedTexts => {
                    showAlertDialog(resolvedTexts, button, window.__lastWasKeyboard);
                });
            });
        } else {
            $body.on('touchend', '.add-to-wish-list:not(.added-to-wish-list)', function () {
                const button = this;

                clearTimeout(touchTimer);
                wishlistIconCallback(button, false);
            });
            $body.on('touchend', '.add-to-wish-list.added-to-wish-list', function () { // short tap
                const button = this;

                clearTimeout(touchTimer);
                wishlistIconCallback(button, true);
            });
            $body.on('touchstart', '.add-to-wish-list.added-to-wish-list', function (e) { // long touch
                const button = this;

                clearTimeout(touchTimer);
                touchTimer = setTimeout(() => {
                    getWishlistItemsWithConfig(button).then(resolvedTexts => {
                        mobileChangeButtonCallback(resolvedTexts, button);
                    });
                }, LONG_PRESS_THRESHOLD);
            });
            $body.on(
                'touchmove touchcancel',
                '.add-to-wish-list.added-to-wish-list',
                function () {
                    clearTimeout(touchTimer);
                }
            );
        }
        $body.on('mouseenter', '.add-to-wish-list', function () {
            const button = this;

            addClass(button, 'm-hovered');

            AlertDialog.closeAll();
            $('.popover.show').popover('hide');

            getWishlistItemsWithConfig(button).then(resolvedTexts => {
                showAlertDialog(resolvedTexts, button, false);
            });
        });
        $body.on('mouseleave', '.add-to-wish-list', function (e) {
            const to = e.relatedTarget;

            removeClass(this, 'm-hovered');

            if ( to && typeof to.closest === 'function' &&
                    (to.closest('.wishlist-alert-dialog')
                        || to.closest('.wishlist-alert-dialog-success'))) {
                            return;
            }
            AlertDialog.restartTimers();
        });
        $body.on('mouseenter', '.strike-wish-list, .loyalty-early-access-locked', function () {
            AlertDialog.closeAll();
        });
        $body.on('click', '.strike-wish-list, .loyalty-early-access-locked', function (e) {
            AlertDialog.closeAll();
            $('.popover.show').popover('hide');
            $(this).popover('show');
            $(this).focus();
        });
        $body.on('keydown', '.wishlist-alert-dialog, .wishlist-alert-dialog-success', function (e) {
            const { key } = e;
            const $dialog = $(this);
            const focusables = $dialog
                .find('a, button, input, [tabindex]:not([tabindex="-1"])')
                .filter(':visible');

            if (!focusables.length) {
                if (currentTriggerButton) {
                    currentTriggerButton.focus();
                }
                return;
            }

            const focusablesArr = focusables.toArray();
            const currentIndex = focusablesArr.indexOf(document.activeElement);

            // Tab key trap logic:
            if (key === EVENT_KEY_TAB) {
                const first = focusablesArr[0];
                const last = focusablesArr[focusablesArr.length - 1];

                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                } else if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    currentTriggerButton?.focus();
                }
            }
        });
    },
    handleWishlistClose: function () {
        $body.on('click', '.wishlist-sheet-btn-done', function () {
            $('#wishlists').modal('hide');
        });
    },
    handleSwatchUpdate: function () {
        $body.on('swatchChangeEventCustom', function (e, data) {
            const { el, productData } = data;

            if (!el || !productData) {
                return;
            }

            const pTileEl = el.closest(SELECTOR_PRODUCT_TILE);

            if (productData.wishlistDisabled || !productData.isDirectlyPurchasable || productData.isFinalSale) {
                showStrikeHearts(pTileEl);
            } else {
                hideStrikeHearts(pTileEl);
            }

            const wishlistIcon = queryFirst('.add-to-wish-list', pTileEl);
            const wishlistStrikeIcon = queryFirst('.strike-wish-list', pTileEl);
            wishlistIcon.dataset.productId = productData.id;
            wishlistStrikeIcon.dataset.productId = productData.id;
            updateWishlistIcon(wishlistIcon, productData.id);
        });

        $body.on('product:afterAttributeChange', function (e, eventData) {
            if (!eventData) {
                return;
            }
            const { container, variantGroupId, groupId } = eventData;
            const { masterid } = container[0].dataset;
            const productInfo = window.productInfo[masterid];
            const variantGroupData = productInfo.variants[variantGroupId];
            if (!variantGroupData) {
                return;
            }

            const { isDirectlyPurchasable, wishlistDisabled, isFinalSale } = variantGroupData;

            const productEl = container[0].closest('.product-detail, .set-items .product-detail, .choose-bonus-product-modal .product-detail, .gift-card-main');

            if (wishlistDisabled || !isDirectlyPurchasable || isFinalSale) {
                showStrikeHearts(productEl);
            } else {
                hideStrikeHearts(productEl);
            }
            const wishlistIcons = queryAll('.pdp-details .add-to-wish-list', productEl);
            const wishlistStrikeIcons = queryAll('.pdp-details .strike-wish-list', productEl);
            wishlistIcons.forEach(wishlistIcon => {
                wishlistIcon.dataset.productId = groupId;
                updateWishlistIcon(wishlistIcon, groupId);
            });
            wishlistStrikeIcons.forEach(wishlistStrikeIcon => {
                wishlistStrikeIcon.dataset.productId = groupId;
            });
        });
    },
    handleSizeUpdate: function () {
        $body.on('product:tileSizeSelected', function (e, data) {
            const { container: pTileEl } = data;
            const { ID, isDirectlyPurchasable, isFinalSale, wishlistDisabled } = getSelectedSizeData(pTileEl) || {};
            if (!ID) {
                return;
            }

            if (wishlistDisabled || !isDirectlyPurchasable || isFinalSale) {
                showStrikeHearts(pTileEl);
            } else {
                hideStrikeHearts(pTileEl);
            }

            const wishlistIcon = queryFirst('.add-to-wish-list', pTileEl);
            const wishlistStrikeIcon = queryFirst('.strike-wish-list', pTileEl);
            wishlistIcon.dataset.productId = ID;
            wishlistStrikeIcon.dataset.productId = ID;
            updateWishlistIcon(wishlistIcon, ID);
        });
        $body.on('product:afterSizeChange', function (e, data) {
            const { productContainer: container, productSizeData: productData, allowWishlist } = data;

            const { ID, isDirectlyPurchasable, isFinalSale, wishlistDisabled } = productData;

            if (!ID) {
                return;
            }

            const pdpContainer = queryFirst('.pdp-details', container);
            if (!pdpContainer) {
                return;
            }

            if (wishlistDisabled || !isDirectlyPurchasable || isFinalSale || !allowWishlist) {
                showStrikeHearts(pdpContainer);
            } else {
                hideStrikeHearts(pdpContainer);
            }

            const wishlistIcons = queryAll('.add-to-wish-list', pdpContainer);
            const wishlistStrikeIcons = queryAll('.strike-wish-list', pdpContainer);
            wishlistIcons.forEach(wishlistIcon => {
                wishlistIcon.dataset.productId = ID;
                updateWishlistIcon(wishlistIcon, ID);
            });
            wishlistStrikeIcons.forEach(wishlistStrikeIcon => {
                wishlistStrikeIcon.dataset.productId = ID;
            });
        });
    },

    initWishListItems: () => {
        initWishlistIconState();
        $body.on('search:showMore', () => {
            initWishlistIconState();
        });
        $body.on('search:sortOptions', () => {
            initWishlistIconState();
        });
        $body.on('search:updateProducts', () => {
            initWishlistIconState();
        });
    }
};
